<script setup lang="ts">
  defineProps({
    message: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
  })
</script>

<template>
  <div class="py-20 text-center">
    <div
      v-if="icon"
      class="mb-8">
      <fa-icon
        :icon="icon"
        class="text-3xl text-primary-500"></fa-icon>
    </div>
    <div class="text-center text-lg text-gray-500 font-bold">
      {{ message }}
    </div>
  </div>
</template>
